// eslint-disable-next-line import/no-named-default
import { default as Tooltip } from '../legacy/Construction/Popover/index';

export default Tooltip;
